import Entity from "./Entity";

export default class PushNotification extends Entity {
    constructor(data) {
        super(data);

        this.attributeKeys = [ "id", "to", "testTo", "title", "message", "scheduledOn", "lastUpdate", "status", "mapIds" ];
    }
}